enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "Login",
  LOGIN_ATTEMPTS = "LoginAttempts",
  COMLOGIN = "LoginByCompany",
  LOGOUT = "Logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  ADD_PERMS = "addPerms",
  PURGE = "purge",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "purgeAuth",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_PERMS = "setPerms",
}

enum Users {
  findPageUser = "findPageUser",
  saveUser = "saveUser",
  blockUser = "blockUser",
  deleteUser = "deleteUser",
  changePasswordSelf = "changePasswordSelf",
  changePassword = "changePassword",
  findUserByName = "findUserByName",
  findAllUser = "findAllUser",
  userDownload = "userDownload",
  findUserPermissions = "findUserPermissions",
  getUserInfo = "getUserInfo",
  getUserByRoleId = "getUserByRoleId"
}
enum Menu {
  addMenu = "addMenu",
  viewMenu = "viewMenu",
  editMenu = "editMenu",
  deleteMenu = "deleteMenu",
  findMenuTree = "findMenuTree",
  findMenu = "findMenu",
  findNavTree = "findNavTree",
}

enum Roles {
  saveRole = "saveRole",
  deleteRole = "deleteRole",
  findPageRole = "findPageRole",
  findAllRole = "findAllRole",
  findRoleMenu = "findRoleMenu",
  saveRoleMenu = "saveRoleMenu",
  findRole = "findRole",
}

enum Dashboard {
  getTotalOrderByLastMonth = "getTotalOrderByLastMonth",
  getSentOrders = "getSentOrders",
  getOrdersByLastMonth = "getOrdersByLastMonth",
  getAmountTotalByProduct = "getAmountTotalByProduct",
}

enum SystemConfig {
  showConfig = "showConfig",
  updateConfig = "updateConfig"
}

enum Log {
  findPageLog = "findPageLog"
}

enum Common {
  getCategoryList = "getCategoryList",
  uploadImg = "uploadImg",
}

///

enum Speaker{
  getSpeakerList = "getSpeakerList",
  findPageSpeaker = "findPageSpeaker",
  saveSpeaker = "saveSpeaker",
  deleteSpeaker = "deleteSpeaker",
}

enum SpeakerLog{
  getSpeakerLogList = "getSpeakerLogList",
  findPageSpeakerLog = "findPageSpeakerLog",
  saveSpeakerLog = "saveSpeakerLog",
  deleteSpeakerLog = "deleteSpeakerLog",
}

enum EmployeeStatusLog{
  getEmployeeStatusLogList = "getEmployeeStatusLogList",
  findPageEmployeeStatusLog = "findPageEmployeeStatusLog",
  saveEmployeeStatusLog = "saveEmployeeStatusLog",
  deleteEmployeeStatusLog = "deleteEmployeeStatusLog",
}

enum CounterLog{
  getCounterLogList = "getCounterLogList",
  findPageCounterLog = "findPageCounterLog",
  saveCounterLog = "saveCounterLog",
  deleteCounterLog = "deleteCounterLog",
}

enum EmployeeStatus{
  getEmployeeStatusList = "getEmployeeStatusList",
  findPageEmployeeStatus = "findPageEmployeeStatus",
  saveEmployeeStatus = "saveEmployeeStatus",
  deleteEmployeeStatus = "deleteEmployeeStatus",
}

enum ExchangeStatus{
  getExchangeStatusList = "getExchangeStatusList",
  findPageExchangeStatus = "findPageExchangeStatus",
  saveExchangeStatus = "saveExchangeStatus",
  deleteExchangeStatus = "deleteExchangeStatus",
}

enum Service{
  getServiceList = "getServiceList",
  findPageService = "findPageService",
  saveService = "saveService",
  deleteService = "deleteService",
}

enum Employee{
  getEmployeeList = "getEmployeeList",
  findPageEmployee = "findPageEmployee",
  saveEmployee = "saveEmployee",
  deleteEmployee = "deleteEmployee",
  selectByUserName = "selectByUserName",
  updateStatus = "updateStatus",
}

enum Counter{
  getCounterList = "getCounterList",
  findPageCounter = "findPageCounter",
  saveCounter = "saveCounter",
  deleteCounter = "deleteCounter",
}

enum Count{
  getCountList = "getCountList",
  findPageCount = "findPageCount",
  saveCount = "saveCount",
  deleteCount = "deleteCount",
}

enum Rating{
  getRatingList = "getRatingList",
  findPageRating = "findPageRating",
  saveRating = "saveRating",
  deleteRating = "deleteRating",
}

enum Booth{
  getBoothList = "getBoothList",
  findPageBooth = "findPageBooth",
  saveBooth = "saveBooth",
  deleteBooth = "deleteBooth",
  getList8BoothNCount = "getList8BoothNCount",
}

////

enum Banners {
  findBannersById = "findBannersById",
  updateBanners = "updateBanners",
  deleteBannersById = "deleteBannersById",
  saveBanners = "saveBanners",
  findPageBanners = "findPageBanners",
  uploadBannerImage = "uploadBannerImage"
}

enum Broadcasts {
  findBroadcastsById = "findBroadcastsById",
  updateBroadcasts = "updateBroadcasts",
  deleteBroadcastsById = "deleteBroadcastsById",
  saveBroadcasts = "saveBroadcasts",
  findPageBroadcasts = "findPageBroadcasts",
  findPageBroadcastsByType = "findPageBroadcastsByType",
}

enum Cameras {
  findCamerasById = "findCamerasById",
  updateCameras = "updateCameras",
  deleteCamerasById = "deleteCamerasById",
  saveCameras = "saveCameras",
  findPageCamerasByType = "findPageCamerasByType",
  findPageCamera = "findPageCamera",
}

enum Feedbacks {
  getAllFeedbackByFilter = "getAllFeedbackByFilter",
  getFeedbackById = "getFeedbackById",
  getResponseById = "getResponseById",
  getAllResponseByFeedbackId = "getAllResponseByFeedbackId",
  insertFeedback = "insertFeedback",
  insertResponsesByFeedbackId = "insertResponsesByFeedbackId",
  updateResponseByFeedbackId = "updateResponseByFeedbackId",
  updateFeedbackById = "updateFeedbackById",
  deleteFeedbackById = "deleteFeedbackById",
  deleteResponseByFeedbackId = "deleteResponseByFeedbackId",
  getFeedBackType = "getFeedBackType",
  listFeedBack = "listFeedBack",
  feedbackHistory = "feedbackHistory",
}

enum Hotlines {
  findHotlinesById = "findHotlinesById",
  updateHotlines = "updateHotlines",
  deleteHotlinesById = "deleteHotlinesById",
  saveHotlines = "saveHotlines",
  findPageHotlines = "findPageHotlines",
  findPageHotlinesByType = "findPageHotlinesByType",
}

enum Travels {
  findTravelsById = "findTravelsById",
  updateTravels = "updateTravels",
  deleteTravelsById = "deleteTravelsById",
  saveTravels = "saveTravels",
  findPageTravels = "findPageTravels",
}

enum Utilities {
  findUtilitiesById = "findUtilitiesById",
  updateUtilities = "updateUtilities",
  deleteUtilitiesById = "deleteUtilitiesById",
  saveUtilities = "saveUtilities",
  findPageUtilities = "findPageUtilities",
}

enum News {
  showNews = "showNews",
  listNews = "listNews",
  saveNews = "saveNews",
  updateNews = "updateNews",
  deleteNews = "deleteNews",
  uploadNewsBanner = "uploadNewsBanner",
  uploadArticleImage = "news:uploadArticleImage",
  removeArticleImage = "news:removeArticleImage",
}

enum Categories {
  showCategories = "showCategories",
  insertCategories = "insertCategories",
  updateCategories = "updateCategories",
  deleteCategories = "deleteCategories",
  uploadCategoriesIcon = "uploadCategoriesIcon",
  listCategories = "listCategories",
  restoreToDefault = "restoreToDefault",
}

enum Meetings {
  showMeetings = "showMeetings",
  listMeetings = "listMeetings",
  insertMeetings = "insertMeetings",
  updateMeetings = "updateMeetings",
  deleteMeetings = "deleteMeetings",
  listUser = "listUser",
  findMeetingsById = "findMeetingsById",
  findPageMeetings = "findPageMeetings"
}

enum Plantations {
  showPlantations = "showPlantations",
  listPlantations = "listPlantations",
  savePlantations = "savePlantations",
  updatePlantations = "updatePlantations",
  deletePlantations = "deletePlantations",
  uploadPlantationsBanner = "uploadPlantationsBanner",
  uploadPlantationsArticleImage = "uploadPlantationsArticleImage",
  removePlantationsArticleImage = "removePlantationsArticleImage",
}

enum Cautionary {
  findPageCautionary = "findPageCautionary",
  saveCautionary = "saveCautionary",
  deleteCautionary = "deleteCautionary",
  uploadCautionaryBanner = "uploadCautionaryBanner",
  uploadArticleImage = "cautionary:uploadArticleImage",
  removeArticleImage = "cautionary:removeArticleImage",
}

enum Questions {
  findPageQuestions = "findPageQuestions",
  saveQuestions = "saveQuestions",
  deleteQuestions = "deleteQuestions",
}

enum Reporting {
  findPageReporting = "findPageReporting",
  saveReporting = "saveReporting",
  deleteReporting = "deleteReporting",
}

enum Department {
  findPageDepartment = "findPageDepartment",
  saveDepartment = "saveDepartment",
  deleteDepartment = "deleteDepartment",
  listDepartment = "listDepartment",
}

enum Appointment {
  findPageAppointment = "findPageAppointment",
  saveAppointment = "saveAppointment",
  deleteAppointment = "deleteAppointment",
}

enum LawQuestions {
  findPageLawQuestions = "findPageLawQuestions",
  saveLawQuestions = "saveLawQuestions",
  deleteLawQuestions = "deleteLawQuestions",
}

enum LawExams {
  findPageLawExams = "findPageLawExams",
  saveLawExams = "saveLawExams",
  deleteLawExams = "deleteLawExams",
}

enum HistoryQuestions {
  findPageHistoryQuestions = "findPageHistoryQuestions",
  saveHistoryQuestions = "saveHistoryQuestions",
  deleteHistoryQuestions = "deleteHistoryQuestions",
}

enum HistoryExams {
  findPageHistoryExams = "findPageHistoryExams",
  saveHistoryExams = "saveHistoryExams",
  deleteHistoryExams = "deleteHistoryExams",
}

enum Zones {
  findPageZones = "findPageZones",
  saveZones = "saveZones",
  deleteZones = "deleteZones",
  listZones = "listZones",
}

enum Trainning {
  findPageTrainning = "findPageTrainning",
  saveTrainning = "saveTrainning",
  deleteTrainning = "deleteTrainning",
  listTrainning = "listTrainning",
}

enum ChatHistory {
  findPageChatHistory = "findPageChatHistory",
  saveChatHistory = "saveChatHistory",
  deleteChatHistory = "deleteChatHistory",
  listChatHistory = "listChatHistory",
}

enum LawType {
  findPageLawType = "findPageLawType",
  saveLawType = "saveLawType",
  deleteLawType = "deleteLawType",
  listLawType = "listLawType",
}

enum QueueNumber {
  getQueueNumber = "getQueueNumber",
  callSpeaker = "callSpeaker",
  completeProcess = "completeProcess",
  cancelProcess = "cancelProcess",
  transferTicket = "transferTicket",
  transferTicket2 = "transferTicket2",
  getQueueList = "getQueueList",
  getDailyStatsByEmployee = "getDailyStatsByEmployee",
  getProcessingQueue = "getProcessingQueue",
  getProcessingQueueList = "getProcessingQueueList",
  byPassQueueNumber = "byPassQueueNumber",
  getProcessingQueueByBooth = "getProcessingQueueByBooth",
}

enum SocialNews {
  showNews = "showSocialNews",
  listNews = "listSocialNews",
  saveNews = "saveSocialNews",
  updateNews = "updateSocialNews",
  deleteNews = "deleteSocialNews",
  uploadNewsBanner = "uploadSocialNewsBanner",
  uploadArticleImage = "socialNews:uploadArticleImage",
  removeArticleImage = "socialNews:removeArticleImage",
}

enum RecruitmentNews {
  showNews = "showRecruitmentNews",
  listNews = "listRecruitmentNews",
  saveNews = "saveRecruitmentNews",
  updateNews = "updateRecruitmentNews",
  deleteNews = "deleteRecruitmentNews",
  uploadNewsBanner = "uploadRecruitmentNewsBanner",
  uploadArticleImage = "RecruitmentNews:uploadArticleImage",
  removeArticleImage = "RecruitmentNews:removeArticleImage",
}

enum RegulationNews {
  showNews = "showRegulationNews",
  listNews = "listRegulationNews",
  saveNews = "saveRegulationNews",
  updateNews = "updateRegulationNews",
  deleteNews = "deleteRegulationNews",
  uploadNewsBanner = "uploadRegulationNewsBanner",
  uploadArticleImage = "regulationNews:uploadArticleImage",
  removeArticleImage = "regulationNews:removeArticleImage",
}

enum RegulationNewsType{
  findPageRegulationNewsType = "findPageRegulationNewsType",
  saveRegulationNewsType = "saveRegulationNewsType",
  deleteRegulationNewsType = "deleteRegulationNewsType",
  listRegulationNewsType = "listRegulationNewsType",
}

enum CiviLifeNews {
  showNews = "showCiviLifeNews",
  listNews = "listCiviLifeNews",
  saveNews = "saveCiviLifeNews",
  updateNews = "updateCiviLifeNews",
  deleteNews = "deleteCiviLifeNews",
  uploadNewsBanner = "uploadCiviLifeNewsBanner",
  uploadArticleImage = "civiLifeNews:uploadArticleImage",
  removeArticleImage = "civiLifeNews:removeArticleImage",
}

enum CiviLifeNewsType{
  findPageCiviLifeNewsType = "findPageCiviLifeNewsType",
  saveCiviLifeNewsType = "saveCiviLifeNewsType",
  deleteCiviLifeNewsType = "deleteCiviLifeNewsType",
  listCiviLifeNewsType = "listCiviLifeNewsType",
}

enum Zalo{
  uploadArticleToOA = "uploadArticleToOA",
  broadcastOAPost = "broadcastOAPost",
}

export {
  Actions,
  Mutations,
  Users,
  Menu,
  Roles,
  Dashboard,
  SystemConfig,
  Log,
  Common,

  ///
  Speaker,
  SpeakerLog,
  EmployeeStatusLog,
  CounterLog,
  EmployeeStatus,
  ExchangeStatus,
  Service,
  Employee,
  Counter,
  Count,
  Rating,
  Booth,
  QueueNumber,
  ////
  Banners,
  Broadcasts,
  Cameras,
  Feedbacks,
  Hotlines,
  Travels,
  Utilities,
  News,
  Categories,
  Meetings,
  Plantations,

  Cautionary,
  Appointment,
  Questions,
  Reporting,
  Department,
  LawQuestions,
  LawExams,
  HistoryQuestions,
  HistoryExams,
  Zones,
  Trainning,
  ChatHistory,
  LawType,

  SocialNews,
  RegulationNews,
  RegulationNewsType,
  CiviLifeNews,
  CiviLifeNewsType,
  Zalo,
  RecruitmentNews
};
